import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-memory-card-completion-dialog',
  templateUrl: './memory-card-completion-dialog.component.html',
  styleUrls: ['./memory-card-completion-dialog.component.css']
})
export class MemoryCardCompletionDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<MemoryCardCompletionDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private router:Router ) { }

  ngOnInit(): void {
    console.log(this.data.isFromMemoryCards)
  }

  close() {
    this.dialogRef.close(true);
  }
  goToChapter(){
    this.dialogRef.close(true);
    if(this.data.isFromMemoryCards){
      localStorage.setItem('currentChapterTabIndex','2');
      this.router.navigate([`selfLearn-V2/chapter`]);
    }else {
      this.router.navigate([`selfLearn-V2`]);
    }

  }

}
